<template>
  <v-app class="survey-container">
    <NavBarHome></NavBarHome>
		<br/>
      <v-banner v-if="impersonation" class="impersonation-banner yellow lighten-2">
      <v-avatar slot="icon" color="deep-orange accent-4" size="40">
        <v-icon color="white">
          people_alt
        </v-icon>
      </v-avatar>
      You are viewing the survey of <strong>{{officeDescription}}</strong>.
      <template v-slot:actions>
        <v-btn color="deep-orange accent-4 white--text" @click="exit()">Exit</v-btn>
      </template>
    	</v-banner>
  	<br/>

    <v-layout class="page-body pt-6 admin-page bg-light-blue">
      <v-layout row>
        <!-- *** help pane (left side) ***  -->
        <v-flex column md2 class="page-help">
          <div>
            <v-btn normal class="form-button" @click="onCancel">
              <v-icon medium>home</v-icon>&nbsp; Home
            </v-btn>
            <hr />
          </div>
          <div>
            <h4>On this page:</h4>
            <ul class="bulleted-list">
              <li>View a list of offices who have not yet submitted their surveys.</li>
              <li>Aggregate your immediate suboffice-level data to complete your own survey.</li>
              <li>View a list of past aggregations.</li>
            </ul>
          </div>
          <div>
            <hr />
            <h4>
              <v-icon>star</v-icon>&nbsp;Tips
            </h4>
            <ul>
              <li>It is best to aggregate data after all submissions are complete.</li>
              <li>You may download your data to a MS Excel spreadsheet.The download link is on the Home page.</li>
            </ul>
          </div>
        </v-flex>

        <!-- *** main body (right side) ***  -->
        <v-flex column md10 mx-0 p-3 pt-6>
          <h1>Aggregate Suboffice Data</h1>

          <v-layout data-app wrap row justify-start>
            <v-flex xs12>
              <h2>"Suboffices That Have Not Submitted"?</h2>
              <p>If Any offices listed in the table, have not submitted their surveys, so their data are may be incomplete, and aggregation done using those offices' data will likely also be incomplete.</p>
              <p>
                Click the User ID to open the office’s survey. Doing so will log you out of your surveyview the progress of the suboffice survey.
              </p>
              <v-layout data-app wrap row justify-center>
                <v-flex xs12 md6 justify-center>
                  <v-data-table
                    dense
                    :headers="aggregationHeaders"
                    :items="subOffices"
                    item-key="nameFirst"
                    class="tableNonCompletes elevation-1"
                  >
                   <template #item.userName={value} >
                    <a href="#" @click="switchuser(value,subOffices); return false;">{{value}}</a>
                  </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <hr />

          <v-layout data-app wrap row justify-start mx-3 mt-3 class="main-bodyXX">
            <v-spacer />
            <v-flex xs12 md8 class="horiz-margin-20">
              <p><u>NEW! There is now one aggregation method: Overwrite.</u></p>
                <p><b>If you have suboffices AND enter data of your own, you will need to add a new suboffice—an “overlay” suboffice—where you can enter your own data.</b> This is because we simplified the aggregation process so only the overwrite method is available. Thus, when you aggregate, all your suboffice-level data will automatically be added together and overwrite (i.e., replace) data you manually entered at your own level. Please contact the support team if you need help with this.</p>
                <p>You can aggregate as many times as you need to.</p>
                <p>Select Overwrite and then the AGGREGATE DATA button.</p>
              <v-radio-group v-model="radioGroup" class="radiosGroup mx-3">
                <v-radio value="radio-1">
                 <template v-slot:label>
                    <div class="labelText">
                      <strong>Overwrite</strong>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-layout data-app wrap row>
                <v-flex xs12>
                  <div class="buttons">
                      <span
                        class="processing-text"
                        :class="{ active: aggregateFlag }"
                      >
                        {{ aggregateMessage }}
                      </span>
                    </div>
                    <v-btn
                      normal
                      class="form-button"
                      @click="onAggregateData(radioGroup)"
                      :disabled="!subOffices || subOffices.length === 0 || aggregateFlag"
                    >Aggregate Data</v-btn>
                    <v-btn normal class="form-button btnOffset" @click="onCancel">Home</v-btn>
                  <p>
                     Note: Only click the button once; the process can take some time.
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer />
          </v-layout>
          <v-layout data-app wrap row justify-start mx-3 mb-3>
            <v-flex xs12>
              <h2>Aggregation History</h2>
              <!-- <p>List of past aggregations/p> -->
              <v-layout data-app wrap row justify-center>
                <v-flex xs12 md6 justify-center>
                  <v-data-table
                    dense
                    :headers="aggregationHistory"
                    :items="aggregationRecords"
                    item-key="aggDate"
                    class="aggHistory">
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
    <Footer></Footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import { authTokenService } from "@/services/authTokenService.js";
import { surveyService } from '@/services/surveyService';
import router from "@/router";
import { officeManagementService } from '@/services/officeManagementService.js';
import { authService } from "@/services/authService.js";

export default {
  name: "SubOfficeAggregation",
  data: () => ({

    aggregationHistory: [
      { text: "Aggregation Date", align: "start", value: "aggregationDate" },
      { text: "Aggregation Type", value: "aggregationTypeId" },
      { text: "Aggregation By", value: "aggregationBy" }
    ],
    aggregationRecords: [],

    aggregationHeaders: [
      { text: "User ID", value: 'userName', class: 'cellclname' },
      { text: "Office Name", value: 'officeName', class: 'cellLink' },
      { text: "Date Last Saved", value: 'updateDate' }
    ],
    subOffices: [],
    aggregateMessage: null,
    aggregateFlag: null,
		impersonation: false
  }),
  methods: {
		exit () {
					router.push({ name: 'admin.stats' });
				},
    onAggregateData (radioGroup) {
      const me = this;
      me.aggregateFlag = true;
      me.aggregateMessage = "Processing please wait, this may take a minute or more.";

      const activeSurveyId = authTokenService.getActiveSurveyId();
      var aggregateType = radioGroup == 'radio-2';

      surveyService.setAggregate(activeSurveyId, aggregateType)
        .then(function (response) {

          me.aggregateMessage = "Successfully completed";
          me.aggregateFlag = false;   // <-- animation stops here

          me.aggregationRecords = [];
          surveyService.getAggregationHistory(activeSurveyId).then(function (response) {
            if (response && response.data) {
              for (var i = 0; i < response.data.length; i++) {
                response.data[i].aggregationTypeId =
                  response.data[i].aggregationTypeId == 2 ? 'Overwrite' : 'Sum all';
                me.aggregationRecords.push(response.data[i]);
              }
            }
          });
        })
        .catch(function (e) {
          me.aggregateFlag = false;   // <-- animation stops here too
          me.aggregateMessage = "Error occurred, please check with administrator " + e;
          throw e;
        });
    },
     onLoad () {
        const me = this;
        const activeSurveyId = authTokenService.getActiveSurveyId();
        me.aggregationRecords = [];
        surveyService.getAggregationHistory(activeSurveyId).then(function (response) {
          if (response && response.data) {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].aggregationTypeId == 2) { response.data[i].aggregationTypeId = 'Overwrite'; } else { response.data[i].aggregationTypeId = 'Sum all'; }
                me.aggregationRecords.push(response.data[i]);
            }
          }
        });
    },
    onCancel () {
      router.push({ name: "landing" });
    },
    switchuser (usernameVal, participatingOfficesList) {
      this.$data.isLoading = true;
      let me = this;
      var uservalue = null;
      var password = null;
      for (var i = 0; i < participatingOfficesList.length; i++) {
            if (usernameVal == participatingOfficesList[i].userName) {
              uservalue = participatingOfficesList[i].userName;
              password = participatingOfficesList[i].showPassword;
              break;
            }
      }
      authService
        .login(uservalue, password)
        .then(function (response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          router.push({ name: "landing" });
        })
        .catch(function (response) {
          console.log("Test handle error in component");
          me.$data.error = true;
          me.$data.isLoading = false;
        });
    }
  },
  mounted () {
    const me = this;
		const claims = authTokenService.getClaims();
		if (claims.userName === "Admin") {
			const activeId = authTokenService.getActiveSurveyId();
			claims.surveyId = activeId;
			me.impersonation = true;
			me.isNotUnderAdmin = "isDisabled";
			officeManagementService.getOfficeBySurveyId(activeId).then(function (response) {
					if (response && response.data) {
						me.officeDescription = response.data.description;
						me.officeId = response.data.id;
					}
			});
		}
    me.aggregationRecords = [];
    const activeSurveyId = authTokenService.getActiveSurveyId();
    surveyService.getAggregationHistory(activeSurveyId).then(function (response) {
			if (response && response.data) {
        for (var i = 0; i < response.data.length; i++) {
           if (response.data[i].aggregationTypeId == 2) { response.data[i].aggregationTypeId = 'Overwrite'; } else { response.data[i].aggregationTypeId = 'Sum all'; }
            me.aggregationRecords.push(response.data[i]);
        }
      }
		});
    me.subOffices = [];
    officeManagementService.getSubOffices(activeSurveyId).then(function (response) {
			if (response && response.data) {
        for (var i = 0; i < response.data.length; i++) {
           me.subOffices.push(response.data[i]);
        }
      }
    });
  }
};
</script>

<style scoped>
.radiosGroup {
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid dimgray;
  padding: 10px 15px 0 15px;
  border-radius: 5px;
  background-color: #e4ebf7;
}

  .radiosGroup .v-radio {
    align-items: flex-start;
  }

ul li {
  text-align: left;
}

.buttons {
  width: 80%;
  margin: 10px auto;
  text-align: center;
}

.buttons button {
  margin-left: 20px;
}

button.btnOffset {
  margin-left: 50px;
}

.v-data-table.aggHistory {
  background-color: #f3f3f3;
}

.v-data-table.aggHistory th.text-start.sortable {
  background-color: #cddbf5; /* WIP - not working, same with border */
  border-bottom: 1px solid gray !important;
}

.labelText {
  color: #2c3e50; /* set to #app color. TODO: Fix this to correctly modify theming */
}
.processing-text {
  color: blue;
  font-weight: 600;
  font-size: 16px;
}

/* Animation only when active */
.processing-text.active {
  animation: pulse 1.5s ease-in-out infinite;
}

.processing-text.active::after {
  content: '';
  animation: dots 1.5s steps(3, end) infinite;
}

@keyframes pulse {
  0% { opacity: 0.4; }
  50% { opacity: 1; }
  100% { opacity: 0.4; }
}

@keyframes dots {
  0% { content: ''; }
  33% { content: '.'; }
  66% { content: '..'; }
  100% { content: '...'; }
}
</style>
